// Date switch
$(function() {
  const FORMAT = 'D. MMMM'
  const $formCalendar = $('.measurement-form-calendar')
  const $formDateInput = $('.measurement-form-date')
  const $formDateShow = $('.measurement-show-date')
  const $clearMeasurement = $('.clear-measurement')
  const $deleteMeasurementBtn = $('.progress-page [data-delete]')
  const date = moment()

  let uri = new URI(location.href)
  let clearMeasurementDate = null
  let clearMeasurementID = null
  let measurementUser = null
  let $historyMeasurementItem = null;

  if(uri.hasQuery('tab', 'weight') === true) {
    $('[href=#tab-weight]').click()
  }

  if(uri.hasQuery('tab', 'waist') === true) {
    $('[href=#tab-waist]').click()
  }

  if(uri.hasQuery('tab', 'glycaemia') === true) {
    $('[href=#tab-glycaemia]').click()
  }

  if(uri.hasQuery('tab', 'hemoglobin') === true) {
    $('[href=#tab-hemoglobin]').click()
  }

  const updateCalendarDate = (days = 0) => {
    date.add(days, 'day')

    $formDateInput.val(date.format('YYYY-MM-DD'))
    $formDateShow.val(date.format('D. MMMM YYYY'))
    $formCalendar.find('span').text(date.format(FORMAT))

    if (moment().isSame(date, 'day')) {
      $formCalendar.find('span').text(lang.get('Today'))
      $formCalendar.find('.next').addClass('disabled')
    } else {
      $formCalendar.find('.next').removeClass('disabled')
    }
  }

  updateCalendarDate()

  $formCalendar.find('.previous').click(() => {
    updateCalendarDate(-1)
  })

  $formCalendar.find('.next').click(function() {
    if ($(this).hasClass('disabled')) return

    updateCalendarDate(1)
  })

  $clearMeasurement.click(function () {
    if($(this).data('date'))
      clearMeasurementDate = $(this).data('date')
    else {
      clearMeasurementID = $(this).data('id')
    }
    measurementUser = $(this).data('user')
    $historyMeasurementItem = $(this).closest('.graph-row')
  });

  $deleteMeasurementBtn.click(function () {
    const type = $(this).data('type')

    if(type === "glycaemia") {
      axios.post('/glykemie/delete/'+clearMeasurementID, {
        user: measurementUser
      }).then(() => {
        if (uri.hasQuery('tab', type) === false) {
          uri.removeSearch("tab");
          uri.addSearch({ tab: type });
        }

        location.replace(uri.readable())
      })
    } else {
      axios.post('/delete_measurement', {
        date: clearMeasurementDate,
        user: measurementUser,
        type
      }).then(() => {
        if (uri.hasQuery('tab', type) === false) {
          uri.removeSearch("tab");
          uri.addSearch({ tab: type });
        }

        location.replace(uri.readable())
      })
    }
  });
})

